'use strict'

import InputError from '../../lib/InputError';
import Failed from '../../lib/Failed';

class VeryfySms {
    
    constructor(options) {
        var self=this;
        grecaptcha.enterprise.ready(async () => {
            self.recaptcha_token = await grecaptcha.enterprise.execute(options.access_key, {action: 'LOGIN'});
        });
    }

    init () {
        var self=this;
        $('form[name="verifysms"]').on('submit', (e) => {
            InputError.reset();
            $('button[type="submit"]').attr('disabled', 'disabled').addClass('disabled');

            var data_form=$(e.currentTarget).serialize();
            data_form=data_form+'&g-recaptcha-response='+self.recaptcha_token;

            console.log($(e.currentTarget).attr('action'));
            $.ajax({
                url: $(e.currentTarget).attr('action'),
                type : "POST",
                dataType : 'json',
                data : data_form,
                success : (data) => {
                    console.log('data =>', data);
                    if (data.status === 1){
                        window.location.replace(App.baseUrl + '/panel/sms/crear-cuenta/' + data.verify_code);
                    } else if (data.status === 2) {
                        Failed.show(data.message);
                    } else {
                        $('button[type="submit"]').removeAttr('disabled').removeClass('disabled');
                        InputError.validate();
                        if (data.error){
                            InputError.show(data.error);
                        }
                    }
                },
                error: function(xhr, resp, text) {
                    console.log(xhr, resp, text);
                }
            });
            return false;
        });
    }
}

export default VeryfySms;